import React, { useState } from "react";
import ProfileGridCard from "./ProfileGridCard";
import ListingDetailModal from "./ListingDetailModal";
import PropTypes from "prop-types";
export default function ProfileDirectoryGrid({ title, items = [], loading }) {
  const [selected, setSelected] = useState(null);

  if (loading) {
    return (
      <div className="card-soft p-4">
        <div className="skeleton w-100" style={{ height: 300 }} />
      </div>
    );
  }

  return (
    <div className="profile-directory">
      {title && <h6 className="fw-bold mb-3">{title}</h6>}
      <div className="profile-grid">
        {items.map((item, idx) => (
          <ProfileGridCard
            key={item.id ?? idx}
            item={item}
            onSelect={setSelected}
          />
        ))}
      </div>
      <ListingDetailModal
        show={!!selected}
        onHide={() => setSelected(null)}
        item={selected}
      />
    </div>
  );
}
ProfileDirectoryGrid.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  loading: PropTypes.bool,
};
